import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Programs.css";

const Programs = () => {
  const navigate = useNavigate();
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ========== CALENDAR CONFIGURATION ==========
  const CALENDAR_ID = "f8f1db5ec8d5e7cd07c41071fd985261966ef07918026388e23139beb13978f6@group.calendar.google.com";
  const CALENDAR_URL = "https://calendar.google.com/calendar/embed?src=f8f1db5ec8d5e7cd07c41071fd985261966ef07918026388e23139beb13978f6%40group.calendar.google.com&ctz=Asia%2FKolkata";
  const API_KEY = "AIzaSyD6bZ45YyaAG1MC2u5gtTnPT1Y7ea00zYk";

  // ========== EVENT IMAGE MAPPING ==========
  const EVENT_IMAGE_MAPPING = {
    "Positive Mindset & Motivation": "mandala.jpg",
    "Think Positive, Live Positive": "mandala.jpg",
    "Mandala Art Therapy": "mandala.jpg",
    "Spiritual Mandala Integration": "mandala.jpg",
    "Mandala Art Therapy / Spiritual Mandala Integration": "mandala.jpg",
    "Innovative Teaching & Learning Strategies": "study-mastery.jpg",
    "Effective Study Skills & Exam Motivation": "study-mastery.jpg",
    "Professional Excellence in Service": "study-mastery.jpg",
    "Joyful Work / Teaching Attitude": "study-mastery.jpg",
    "Building a Harmonious Workplace / Community": "change.jpg",
    "Leadership & Educational / Personal Management Skills": "change.jpg",
    "Synodal Leadership & Collaborative Ministry": "change.jpg",
    "Leadership Skills for the Future (Youth)": "change.jpg",
    "Value-Based Education & Character Formation": "believe.jpg",
    "Purpose of Life & Meaningful Living / Teaching": "believe.jpg",
    "Integrity, Values & Moral Clarity": "believe.jpg",
    "Value-Based Work Ethics": "believe.jpg",
    "Student Psychology & Behaviour Understanding": "overcome-fear.jpg",
    "Understanding Modern Youth Psychology (for Formators)": "overcome-fear.jpg",
    "Understanding Children's Emotions": "overcome-fear.jpg",
    "Peer Pressure & Healthy Relationships": "overcome-fear.jpg",
    "Effective Communication Skills / Public Speaking": "design-future.jpg",
    "Teamwork & Harmony": "design-future.jpg",
    "Campus Hospitality & Student Support": "art.jpg",
    "Healthy Discipline Without Shouting": "art.jpg",
    "Academic Support Without Pressure": "art.jpg",
    "Personal Growth & Self-Confidence": "positive.jpg",
    "Raising Confident & Resilient Children": "positive.jpg",
    "Discover Your Purpose & Passion (Youth)": "positive.jpg",
    "Time Management & Smart Work": "parenting.jpg",
    "Focus & Concentration Mastery": "parenting.jpg",
    "Focus, Discipline & Goal Setting (Youth)": "parenting.jpg",
    "Digital Addiction: Mobile / Social Media / Gaming Control": "mindset.jpg",
    "Digital Discipline (for Religious Life)": "mindset.jpg",
    "Digital Literacy for Senior Citizens": "mindset.jpg",
    "Safe & Smart Internet Parenting": "mindset.jpg",
    "Mindfulness & Emotional Well-Being / Stress-Free Mind": "confidence.jpg",
    "Mental Health Awareness for Parents": "confidence.jpg",
    "Emotional Well-Being in Later Life (Loneliness, Peace)": "confidence.jpg",
    "Healthy Choices & Substance Abuse Awareness": "communication.jpg",
    "Healthy Lifestyle & Senior Self-Care": "communication.jpg",
    "Healthy Ageing & Joyful Living": "communication.jpg",
    "Positive Parenting for Today's Generation": "mandala.jpg",
    "Parenting Teenagers with Wisdom": "mandala.jpg",
    "Strengthening Family Bonding & Traditions": "mandala.jpg",
    "Family Emotional Management": "communication.jpg",
    "Strong Family & Community Connections (for Seniors)": "communication.jpg",
    "Consecrated Identity & Religious Vocation Renewal": "change.jpg",
    "Emotional Maturity in Community Life": "change.jpg",
    "Handling Burnout, Fatigue & Spiritual Renewal": "change.jpg",
    "Inner Healing & Psycho-Spiritual Growth": "change.jpg",
    "Prayerfulness in a Busy World": "change.jpg",
    "Safeguarding & Responsible Ministry": "change.jpg",
    "Prophetic Mission & Evangelization": "change.jpg",
    "Spiritual Resilience & Hope in Difficult Times": "change.jpg",
    "Spiritual Growth & Meaningful Living (Youth)": "change.jpg",
    "Memory Boost & Brain Fitness": "positive.jpg",
    "Managing Worry & Life Transitions (for Seniors)": "positive.jpg",
    "Storytelling & Sharing Life Lessons": "positive.jpg",
    "Creativity, Innovation & Problem-Solving (Youth)": "design-future.jpg",
    "Gratitude & Unity Practices": "art.jpg",
    "Culture of Gratitude in Community Life": "art.jpg"
  };

  const getEventImage = (eventTitle) => {
    if (!eventTitle) return "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=250&fit=crop&auto=format";
    
    if (EVENT_IMAGE_MAPPING[eventTitle]) {
      return `/images/programs/${EVENT_IMAGE_MAPPING[eventTitle]}`;
    }
    
    const titleLower = eventTitle.toLowerCase();
    const keywordMap = {
      "mandala": "mandala.jpg", "art therapy": "mandala.jpg", "spiritual": "mandala.jpg", "positive": "mandala.jpg", "mindset": "mandala.jpg",
      "study": "study-mastery.jpg", "teaching": "study-mastery.jpg", "learning": "study-mastery.jpg", "academic": "study-mastery.jpg", "excellence": "study-mastery.jpg",
      "workplace": "change.jpg", "community": "change.jpg", "leadership": "change.jpg", "management": "change.jpg", "synodal": "change.jpg",
      "value": "believe.jpg", "character": "believe.jpg", "purpose": "believe.jpg", "meaningful": "believe.jpg", "integrity": "believe.jpg", "ethics": "believe.jpg",
      "student": "overcome-fear.jpg", "psychology": "overcome-fear.jpg", "behavior": "overcome-fear.jpg", "youth": "overcome-fear.jpg", "children": "overcome-fear.jpg", "teenager": "overcome-fear.jpg", "peer": "overcome-fear.jpg",
      "communication": "design-future.jpg", "public speaking": "design-future.jpg", "teamwork": "design-future.jpg", "harmony": "design-future.jpg",
      "campus": "art.jpg", "hospitality": "art.jpg", "support": "art.jpg", "discipline": "art.jpg",
      "confidence": "positive.jpg", "growth": "positive.jpg", "passion": "positive.jpg", "resilient": "positive.jpg", "discover": "positive.jpg",
      "time": "parenting.jpg", "focus": "parenting.jpg", "concentration": "parenting.jpg", "goal": "parenting.jpg",
      "digital": "mindset.jpg", "internet": "mindset.jpg", "mobile": "mindset.jpg", "social media": "mindset.jpg", "gaming": "mindset.jpg", "addiction": "mindset.jpg",
      "mindfulness": "confidence.jpg", "stress": "confidence.jpg", "mental health": "confidence.jpg", "emotional": "confidence.jpg", "well-being": "confidence.jpg",
      "health": "communication.jpg", "lifestyle": "communication.jpg", "ageing": "communication.jpg", "senior": "communication.jpg", "healthy": "communication.jpg",
      "parenting": "mandala.jpg", "family": "mandala.jpg", "bonding": "mandala.jpg",
      "religious": "change.jpg", "vocation": "change.jpg", "prayer": "change.jpg", "ministry": "change.jpg", "inner healing": "change.jpg",
      "memory": "positive.jpg", "brain": "positive.jpg", "storytelling": "positive.jpg", "worry": "positive.jpg",
      "creativity": "design-future.jpg", "innovation": "design-future.jpg", "problem-solving": "design-future.jpg",
      "gratitude": "art.jpg", "unity": "art.jpg", "culture": "art.jpg"
    };
    
    for (const [keyword, image] of Object.entries(keywordMap)) {
      if (titleLower.includes(keyword.toLowerCase())) {
        return `/images/programs/${image}`;
      }
    }
    
    return "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=250&fit=crop&auto=format";
  };

  // ========== FETCH GOOGLE CALENDAR EVENTS ==========
  useEffect(() => {
    const fetchGoogleCalendarEvents = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const now = new Date();
        const timeMin = now.toISOString();
        const timeMax = new Date(now.getTime() + 90 * 24 * 60 * 60 * 1000).toISOString();
        
        const calendarUrl = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(CALENDAR_ID)}/events?key=${API_KEY}&timeMin=${timeMin}&timeMax=${timeMax}&singleEvents=true&orderBy=startTime`;
        
        const response = await fetch(calendarUrl, {
          method: 'GET',
          headers: { 'Accept': 'application/json' }
        });
        
        if (response.status === 403) {
          setError("Calendar access restricted. Please check API configuration.");
          return;
        }
        
        if (!response.ok) {
          throw new Error(`API Error: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.error) {
          setError(`Google Calendar Error: ${data.error.message}`);
          return;
        }
        
        if (!data.items || data.items.length === 0) {
          setEvents([]);
          setLoading(false);
          return;
        }
        
        const formattedEvents = data.items.map((event, index) => {
          const start = event.start.dateTime || event.start.date;
          const end = event.end.dateTime || event.end.date;
          const eventDate = new Date(start);
          
          const getTimeString = () => {
            if (event.start.date) return "All Day";
            const startTime = new Date(start).toLocaleTimeString('en-IN', { 
              hour: '2-digit', 
              minute: '2-digit',
              hour12: true 
            });
            const endTime = new Date(end).toLocaleTimeString('en-IN', { 
              hour: '2-digit', 
              minute: '2-digit',
              hour12: true 
            });
            return `${startTime} - ${endTime}`;
          };
          
          const getDateString = () => {
            return eventDate.toLocaleDateString('en-IN', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            });
          };
          
          const description = event.description || "Join us for this transformative event. Details will be provided upon registration.";
          const location = event.location || "Servite Counselling Centre, Nagercoil";
          
          const extractRegistrationLink = (desc) => {
            if (!desc) return "#";
            const formRegex = /https:\/\/docs\.google\.com\/forms\/[^\s<>"]+/gi;
            const linkMatch = desc.match(formRegex);
            return linkMatch && linkMatch[0] ? linkMatch[0] : "#";
          };
          
          const cleanDescription = (desc) => {
            if (!desc) return "Join us for this transformative event. Details will be provided upon registration.";
            let cleaned = desc.replace(/<[^>]*>/g, '');
            cleaned = cleaned.replace(/https?:\/\/[^\s]+/g, '');
            cleaned = cleaned.replace(/\n+/g, ' ');
            cleaned = cleaned.trim();
            
            if (cleaned.length > 120) {
              return cleaned.substring(0, 120) + "...";
            }
            
            return cleaned || "Join us for this transformative event. Details will be provided upon registration.";
          };
          
          return {
            id: event.id || `event-${index}`,
            title: event.summary || "Upcoming Workshop",
            date: getDateString(),
            time: getTimeString(),
            description: cleanDescription(event.description),
            registrationLink: extractRegistrationLink(event.description),
            location: location,
            image: getEventImage(event.summary)
          };
        });
        
        setEvents(formattedEvents);
        setLoading(false);
        
      } catch (error) {
        console.error("Error fetching calendar events:", error);
        setLoading(false);
        setError("Unable to load events at this time.");
      }
    };
    
    fetchGoogleCalendarEvents();
    const interval = setInterval(fetchGoogleCalendarEvents, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const handleEventRegistration = (registrationLink) => {
    if (registrationLink && registrationLink !== "#") {
      window.open(registrationLink, "_blank");
    }
  };

  const handleViewCalendar = () => {
    window.open(CALENDAR_URL, "_blank");
  };

  // ========== SIMPLIFIED PROGRAMS DATA ==========
  const programs = [
    { 
      name: "Mandala Art Therapy Workshop", 
      description: "Creative therapy for stress relief and self-discovery through artistic expression",
      overview: "This program uses artistic mandala creation to help manage stress, reduce anxiety, and promote emotional healing. Participants learn creative expression techniques for better mental wellness. The workshop includes guided meditation through art, color therapy, and symbolic expression methods.",
      outcomes: "• Reduced stress levels and anxiety • Improved emotional regulation and expression • Enhanced self-awareness and mindfulness • Development of creative coping mechanisms • Increased focus and concentration",
      therapist: "Sr. Rosari Sahaya Rani (M.Sc. in Counselling & Psychotherapy)",
      duration: "1 Day Workshop",
      type: "Art Therapy",
      experience: "15+ years experience in art therapy"
    },
    { 
      name: "Study Skills Mastery Program", 
      description: "Advanced learning techniques and memory enhancement for academic excellence",
      overview: "Designed for students to master effective study methods, time management, and exam preparation strategies for better academic performance. Covers note-taking techniques, memory enhancement methods, and concentration exercises.",
      outcomes: "• Higher academic grades and performance • Efficient learning and information retention • Reduced exam anxiety and stress • Development of lifelong study habits • Improved time management skills",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Academic Development",
      experience: "Extensive experience with CBSE, ICSE students"
    },
    { 
      name: "Personal Transformation Journey", 
      description: "Leadership development and personal growth for meaningful change",
      overview: "Focuses on developing leadership skills, personal values, and strategies for creating positive change in personal and professional life. Includes goal setting, vision creation, and action planning.",
      outcomes: "• Clear life direction and purpose • Enhanced leadership and decision-making abilities • Improved problem-solving skills • Greater life satisfaction and fulfillment • Better community impact",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Leadership Development",
      experience: "25+ years transformational training experience"
    },
    { 
      name: "Confidence Building Workshop", 
      description: "Self-esteem development and confidence building",
      overview: "Evidence-based techniques to build strong self-worth, overcome self-doubt, and develop personal empowerment. Uses cognitive-behavioral approaches and positive psychology interventions.",
      outcomes: "• Stronger self-confidence and self-esteem • Reduced self-doubt and negative self-talk • Better assertiveness in communication • Improved self-image and identity • Enhanced personal empowerment",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Personal Growth",
      experience: "Specialized in confidence building for 15+ years"
    },
    { 
      name: "Anxiety Management Program", 
      description: "Cognitive-behavioral techniques for overcoming fear and anxiety",
      overview: "Professional therapy using evidence-based techniques to conquer fears, manage anxiety, and build emotional resilience. Includes relaxation techniques and coping strategies.",
      outcomes: "• Reduced anxiety levels and panic attacks • Better fear management and control • Improved emotional regulation • Enhanced coping skills • Increased personal courage",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Therapeutic Intervention",
      experience: "Expert in anxiety management techniques"
    },
    { 
      name: "Future Planning Workshop", 
      description: "Strategic planning and hope building for meaningful life direction",
      overview: "Helps create clear future visions, develop practical plans, and implement actionable steps for achieving personal and professional goals. Focuses on hope building and optimism development.",
      outcomes: "• Clear life goals and future vision • Actionable and practical plans • Enhanced optimism and hope • Better goal achievement rates • Increased life purpose and meaning",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Strategic Planning",
      experience: "Guided 1000+ individuals in career planning"
    },
    { 
      name: "Positive Parenting Program", 
      description: "Effective parenting strategies and family relationship building",
      overview: "Teaches positive discipline methods, effective communication, and relationship-building techniques for stronger family dynamics. Covers child psychology and developmental stages.",
      outcomes: "• Improved parent-child relationships • Better communication and understanding • Effective and compassionate discipline • Stronger family bonds and connections • Reduced family conflicts",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Family Counselling",
      experience: "Extensive experience with family systems"
    },
    { 
      name: "Mindfulness & Resilience", 
      description: "Mental toughness training and emotional strength development",
      overview: "Focuses on developing mental resilience, optimistic thinking patterns, and lasting emotional strength through evidence-based techniques and mindfulness practices.",
      outcomes: "• Enhanced mental toughness and resilience • Better stress management abilities • Improved emotional strength and stability • Increased life satisfaction • Better adaptive coping skills",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Mental Wellness",
      experience: "Certified mindfulness practitioner"
    },
    { 
      name: "Communication Excellence", 
      description: "Interpersonal skills and professional communication mastery",
      overview: "Develops interpersonal effectiveness, active listening skills, and relationship-building techniques for personal and professional success. Covers verbal and non-verbal communication.",
      outcomes: "• Better communication and expression skills • Improved personal and professional relationships • Effective conflict resolution • Stronger social connections • Enhanced professional effectiveness",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Communication Skills",
      experience: "Trained professionals and corporates"
    },
    { 
      name: "Joyful Living Program", 
      description: "Happiness cultivation and life satisfaction strategies",
      overview: "Helps individuals find happiness and fulfillment through mindfulness practices, positive psychology, gratitude techniques, and joyful living habits.",
      outcomes: "• Increased daily happiness and joy • Better stress and anxiety management • Improved mindfulness and present awareness • Enhanced work-life balance • Greater life satisfaction",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Positive Psychology",
      experience: "Expert in positive psychology interventions"
    },
    { 
      name: "Digital Wellness Workshop", 
      description: "Healthy technology use and digital balance strategies",
      overview: "Addresses digital addiction and promotes healthy technology habits through awareness, practical balance strategies, and mindful technology use techniques.",
      outcomes: "• Healthier digital habits and usage • Reduced screen time and dependency • Better digital boundaries • Mindful technology consumption • Improved real-life balance",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Digital Wellness",
      experience: "Specialized in digital addiction counseling"
    },
    { 
      name: "Career Guidance Program", 
      description: "Professional development and career path planning",
      overview: "Provides comprehensive career guidance for professional development, skill assessment, strategic career planning, and networking strategies for career advancement.",
      outcomes: "• Clear career direction and path • Professional skill development • Better goal achievement • Enhanced professional growth • Improved networking abilities",
      therapist: "Sr. Rosari Sahaya Rani",
      duration: "1 Day Workshop",
      type: "Career Counselling",
      experience: "25+ years career guidance experience"
    }
  ];

  const handleLearnMore = (program) => {
    setSelectedProgram(program);
    setShowModal(true);
    document.body.classList.add('modal-open');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProgram(null);
    document.body.classList.remove('modal-open');
  };

  const handleBookService = (programName) => {
    navigate("/contact", { 
      state: { 
        scrollToBooking: true,
        selectedService: programName
      } 
    });
    handleCloseModal();
  };

  const handleScheduleConsultation = () => {
    navigate("/contact", { 
      state: { 
        scrollToBooking: true,
        selectedService: "Program Consultation"
      } 
    });
  };

  return (
    <div className="programs-page">
      {/* Hero Section */}
      <section className="programs-hero">
        <div className="container">
          <div className="hero-content"><br></br>
            <h1 className="hero-title">Professional Therapeutic Programs</h1>
            <p className="hero-subtitle">
              Evidence-based workshops and programs for personal growth, mental wellness and professional development
            </p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">12</span>
                <span className="stat-label">Programs</span>
              </div>
              <div className="stat">
                <span className="stat-number">15+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat">
                <span className="stat-number">1000+</span>
                <span className="stat-label">Participants</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Upcoming Events Section */}
      <section className="events-section">
        <div className="container">
          <div className="section-header">
            <h2>Upcoming Events & Workshops</h2>
            <p>Live events from our Google Calendar</p>
          </div>

          <div className="events-content">
            {loading ? (
              <div className="events-loading">
                <div className="loading-spinner"></div>
                <p>Loading upcoming events...</p>
              </div>
            ) : error ? (
              <div className="events-error">
                <h3>Unable to Load Events</h3>
                <p>{error}</p>
                <button 
                  className="btn-calendar"
                  onClick={handleViewCalendar}
                >
                  View Calendar
                </button>
              </div>
            ) : events.length > 0 ? (
              <div className="events-grid">
                {events.slice(0, 3).map((event) => (
                  <div key={event.id} className="event-card">
                    <div className="event-image">
                      <img 
                        src={event.image} 
                        alt={event.title}
                        onError={(e) => {
                          console.error("Failed to load image:", event.image);
                          e.target.src = "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=250&fit=crop&auto=format";
                        }}
                      />
                    </div>
                    <div className="event-content">
                      <h3>{event.title}</h3>
                      <div className="event-details">
                        <div className="detail">
                          <strong>Date:</strong> {event.date}
                        </div>
                        <div className="detail">
                          <strong>Time:</strong> {event.time}
                        </div>
                        <div className="detail">
                          <strong>Location:</strong> {event.location}
                        </div>
                      </div>
                      <p>{event.description}</p>
                      <div className="event-actions">
                        <button 
                          className="btn-register"
                          onClick={() => handleEventRegistration(event.registrationLink)}
                        >
                          Register Now
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-events">
                <h3>No Upcoming Events</h3>
                <p>Check back soon for new workshops</p>
                <button 
                  className="btn-calendar"
                  onClick={handleViewCalendar}
                >
                  View Calendar
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Programs Grid Section */}
      <section className="programs-grid-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Therapeutic Programs</h2>
            <p>Professional programs designed for transformative growth and mental wellness</p>
          </div>

          <div className="programs-grid">
            {programs.map((program, index) => (
              <div key={index} className="program-card">
                <div className="card-header">
                  <h3>{program.name}</h3>
                  <span className="program-type">{program.type}</span>
                </div>
                <div className="card-body">
                  <p className="program-description">{program.description}</p>
                  <div className="program-info">
                    <div className="info-item">
                      <strong>Duration:</strong> {program.duration}
                    </div>
                    <div className="info-item">
                      <strong>Facilitator:</strong> Sr. Rosari Sahaya Rani
                    </div>
                  </div>
                  <button 
                    className="btn-learn-more"
                    onClick={() => handleLearnMore(program)}
                  >
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Program Detail Modal */}
      {showModal && selectedProgram && (
        <div className="program-modal-overlay" onClick={handleCloseModal}>
          <div className="program-modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="program-modal">
              <button className="modal-close" onClick={handleCloseModal}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              
              <div className="modal-header">
                <h2>{selectedProgram.name}</h2>
                <p className="modal-subtitle">{selectedProgram.description}</p>
              </div>

              <div className="modal-content">
                <div className="modal-section">
                  <h3>Program Overview</h3>
                  <p>{selectedProgram.overview}</p>
                </div>

                <div className="modal-section">
                  <h3>Program Outcomes</h3>
                  <p>{selectedProgram.outcomes}</p>
                </div>

                <div className="modal-section">
                  <h3>Program Details</h3>
                  <div className="details-grid">
                    <div className="detail-item">
                      <strong>Duration:</strong>
                      <span>{selectedProgram.duration}</span>
                    </div>
                    <div className="detail-item">
                      <strong>Program Type:</strong>
                      <span>{selectedProgram.type}</span>
                    </div>
                    <div className="detail-item">
                      <strong>Experience Level:</strong>
                      <span>{selectedProgram.experience}</span>
                    </div>
                    <div className="detail-item">
                      <strong>Facilitator:</strong>
                      <span>{selectedProgram.therapist}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button 
                  className="btn-enroll"
                  onClick={() => handleBookService(selectedProgram.name)}
                >
                  Enroll in Program
                </button>
                <button 
                  className="btn-close"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Programs;